export default __webpack_public_path__ + "static/media/b19.04f92741.jpg";